import { render } from "./BoxInformation.vue?vue&type=template&id=247359e2&scoped=true"
import script from "./BoxInformation.vue?vue&type=script&lang=js"
export * from "./BoxInformation.vue?vue&type=script&lang=js"

import "./BoxInformation.vue?vue&type=style&index=0&id=247359e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247359e2"]])

export default __exports__